/* tslint:disable */
/* eslint-disable */
/**
 * Ак Барс Недвижимость (Images-Service) API
 * Инструменты разработчика: [ [Документация API. Swagger](/docs/) ] [ [Документация API. Redoc](/redoc/) ] [ [Панель администрирования](/admin/) ] [ [Документация Image-Service](/api/attachments/docs/) ]
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Attachment
 */
export interface Attachment {
    /**
     * 
     * @type {number}
     * @memberof Attachment
     */
    id?: number;
    /**
     * 
     * @type {Date}
     * @memberof Attachment
     */
    createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof Attachment
     */
    updatedAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof Attachment
     */
    type?: AttachmentTypeEnum;
}

export function AttachmentFromJSON(json: any): Attachment {
    return AttachmentFromJSONTyped(json, false);
}

export function AttachmentFromJSONTyped(json: any, ignoreDiscriminator: boolean): Attachment {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'createdAt': !exists(json, 'createdAt') ? undefined : (new Date(json['createdAt'])),
        'updatedAt': !exists(json, 'updatedAt') ? undefined : (new Date(json['updatedAt'])),
        'type': !exists(json, 'type') ? undefined : json['type'],
    };
}

export function AttachmentToJSON(value?: Attachment | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'createdAt': value.createdAt === undefined ? undefined : (value.createdAt.toISOString()),
        'updatedAt': value.updatedAt === undefined ? undefined : (value.updatedAt.toISOString()),
        'type': value.type,
    };
}

/**
* @export
* @enum {string}
*/
export enum AttachmentTypeEnum {
    Unknown = 'unknown',
    PassportFront = 'passport_front',
    PassportReverse = 'passport_reverse',
    Inn = 'inn',
    Snils = 'snils',
    Converted = 'converted',
    BirthCertificate = 'birth_certificate',
    ChildRepresentativeApproval = 'child_representative_approval',
    MarriageContract = 'marriage_contract',
    SpousesNotarialConsent = 'spouses_notarial_consent',
    PassportOriginal = 'passport_original',
    PassportTranslation = 'passport_translation',
    Apostille = 'apostille',
    MaternalCapitalCertificate = 'maternal_capital_certificate',
    MaternalCapitalCertificateBalance = 'maternal_capital_certificate_balance',
    MortgageCertificate = 'mortgage_certificate',
    SubsidyCertificate = 'subsidy_certificate'
}


